// src/components/ServerDataExtraction/ServerDataExtractionHeader.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServerDataExtractionHeader = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="data-hero-wrap">
      <h1 className="data-hero-title">
        DATA <span className="data-hero-title-accent">EXTRACTION</span>
      </h1>
      <p className="data-hero-subtitle">
        {isEn
          ? 'Connect to a target server below to retrieve available data like MOTD, player lists, plugins, and more.'
          : 'Подключитесь к целевому серверу ниже, чтобы получить доступные данные, такие как MOTD, списки игроков, плагины и многое другое.'}
      </p>
    </section>
  );
};

export default ServerDataExtractionHeader;